import { useCallback } from "react";
import { graphql, useMutation } from "react-relay";
import * as Haptic from "expo-haptics";

import { Platform } from "react-native";
import { useOnStorecastLeaveScreenMutation } from "./__generated__/useOnStorecastLeaveScreenMutation.graphql";

export function useOnStorecastLeaveScreen(storecastId: string) {
  const [mutation] = useMutation<useOnStorecastLeaveScreenMutation>(graphql`
    mutation useOnStorecastLeaveScreenMutation(
      $storecastId: ID!
      $subject: StorecastFocusSubjectNewInput
    ) {
      dashboard(dashboardId: $storecastId) {
        setNewFocus(subject: $subject) {
          subject {
            nodeId
            detailItemId
          }
        }
        setTemporaryScreenId(screenId: null) {
          id
          screens {
            id
          }
          temporaryScreen {
            id
          }
        }
      }
    }
  `);

  const onStorecastLeaveScreen = useCallback(() => {
    if (Platform.OS === "ios") {
      Haptic.impactAsync(Haptic.ImpactFeedbackStyle.Medium);
    }
    mutation({
      updater: (store) => {
        const storecast = store.get(storecastId);
        if (!storecast) return;
        storecast.setValue(null, "focusedNodeId");
        storecast.setValue(null, "focusedDetailItemId");
      },
      variables: {
        storecastId,
        subject: null,
      },
    });
  }, [mutation, storecastId]);

  return onStorecastLeaveScreen;
}
